import { useEffect, useState } from "react";
import { api } from "@/lib/api";

// Recent Conversations (COP-UX-151, COP-MEM-091/092/095): governed thread history —
// titles/timestamps only; reopening revalidates authorization server-side (COP-MEM-093)
// and dynamic facts are re-read live on the next turn (COP-MEM-094).
export default function ConversationList({ currentId, onSelect }) {
  const [sessions, setSessions] = useState(null);

  useEffect(() => {
    (async () => {
      try {
        const r = await api.get("/copilot/sessions");
        setSessions(r.data || []);
      } catch {
        setSessions([]);
      }
    })();
  }, []);

  if (sessions === null) {
    return <p className="p-3 text-xs text-warmgrey">Loading conversations…</p>;
  }
  if (sessions.length === 0) {
    return <p className="p-3 text-xs text-warmgrey">No conversations yet — ask something to begin.</p>;
  }
  const hide = async (e, id) => {
    e.stopPropagation();
    try {
      await api.post(`/copilot/sessions/${id}/hide`);  // V5-H2 D-H3: hidden from this list only; nothing deleted
      setSessions((prev) => prev.filter((s) => s.id !== id));
      if (id === currentId) onSelect(null);
    } catch { /* keep list unchanged */ }
  };
  return (
    <div data-testid="copilot-history-list">
      {sessions.map((s) => (
        <div key={s.id} className="flex items-start">
        <button
          onClick={() => onSelect(s.id)}
          className={`block min-w-0 flex-1 rounded-sm px-3 py-2 text-left text-sm transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-terracotta ${
            s.id === currentId ? "bg-sand text-charcoal" : "text-warmgrey hover:bg-sand/60 hover:text-charcoal"
          }`}
          data-testid="copilot-history-item"
        >
          <span className="block break-words">{s.title || "Conversation"}</span>
          {s.updated_at && (
            <span className="block text-[10px] text-warmgrey">{new Date(s.updated_at).toLocaleString()}</span>
          )}
        </button>
        <button type="button" onClick={(e) => hide(e, s.id)} className="mt-1 min-h-[32px] shrink-0 rounded-sm px-2 py-1 text-[10px] text-warmgrey hover:bg-sand hover:text-charcoal focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-terracotta"
          aria-label={`Hide conversation ${s.title || ""} from recent list`} title="Hide from Recent (history and audit are kept)" data-testid="copilot-history-hide">Hide</button>
        </div>
      ))}
    </div>
  );
}
